import { useState, type ReactNode, type FC } from 'react';
import CareerListingContext, { type CareerListingContextProps, type CareerListingProps } from './CareerListingContext';
import { type ActiveFilter } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { getActiveFiltersFromURL, getPageFromURL } from '3-components/ListingApp/ListingFilters/ListingFilterHelpers';

interface CareerListingProviderProps extends CareerListingProps {
    children: ReactNode;
}

const CareerListingProvider: FC<CareerListingProviderProps> = ({
    listing,
    children,
    ...restProps
}) => {
    const activeFiltersInitialValue = getActiveFiltersFromURL(listing.filters);
    const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>(activeFiltersInitialValue);

    const [page, setPage] = useState(getPageFromURL());

    const providerValue: CareerListingContextProps = {
        activeFilters,
        setActiveFilters,
        page,
        setPage,
        listing,
        ...restProps,
    };

    return (
        <CareerListingContext.Provider value={providerValue}>
            {children}
        </CareerListingContext.Provider>
    );
};

export default CareerListingProvider;
